export default __webpack_public_path__ + "static/Switzer-Variable-fa6516b65d6b10e1a3c70914bf00d8a1.ttf";